import * as React from 'react';
export const sofortSvg = React.forwardRef(function sofortSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#2E3235',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.2 26h16.232l3.334-20H9.534L6.2 26Zm9.371-12.366c0 .357.302.536 1.616 1.208 1.68.865 2.74 1.76 2.74 3.385 0 1.999-1.647 3.549-4.704 3.549-1.964 0-3.264-.671-4.166-1.327l.507-3.102c.871.82 2.345 1.625 3.613 1.625.728 0 1.282-.253 1.282-.7 0-.418-.332-.627-1.649-1.313-1.471-.76-2.709-1.625-2.709-3.28 0-1.924 1.696-3.52 4.659-3.52 1.49 0 3.105.52 4.858 1.516a7.348 7.348 0 0 0-1.457 2.574c-1.24-1.192-2.504-1.287-3.338-1.287-.729 0-1.252.224-1.252.672Z',
      fill: '#E5E5E0',
    }),
  );
});
sofortSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var sofort = {
  category: 'brand',
  colorable: false,
  name: 'sofort',
  svg: sofortSvg,
};
